import Rateio from "@/Models/Financeiro/Titulo/Rateio";
import { BooleanProps } from "@/utility-types";
import { FormInstance, Form, Tooltip,Row, Col, InputNumber } from "antd";
import CentroCustoSelect from "../../CentroConta/CentroCustoSelect";
import PlanoDeContasSelect from "../../PlanoDeContas/PlanoDeContasSelect";
import InputPreco from "@/Components/Base/Input/InputPreco";
import { EnumPlanoContasTipoMovimentacao } from "@/Models/Financeiro/PlanoContasTipo";
import { EnumRegistroTipo } from "@/Models/Financeiro/PlanoContasTipoRegistro";
import { useEffect } from "react";

export interface ITituloRaterioFormItemProps<T> {
    form:FormInstance<T>,
    nameBase:string[],
    namePath:string[],
    valorTotalARatear:number,
    disable?: BooleanProps<Rateio>,
    defaultValues?: Rateio,
    isAReceber?: boolean,
    habilitarValorFixo?: boolean
}
export default function TituloRaterioFormItem<T>({
    form,
    nameBase,
    namePath,
    valorTotalARatear,
    disable,
    defaultValues,
    isAReceber,
    habilitarValorFixo
}:ITituloRaterioFormItemProps<T>) {
    nameBase = nameBase ?? [];
    valorTotalARatear = valorTotalARatear ?? 0;
    isAReceber = isAReceber ?? false;
    habilitarValorFixo = habilitarValorFixo ?? true;

    const percentualForm = Form.useWatch([...namePath, "percentual"], form);
    const rateioForm = Form.useWatch([...namePath], form);

    // useEffect(() => {
    //     const newValue = (form.getFieldValue([...namePath, "percentual"]) ?? 0) * valorTotalARatear;

    //     form.setFieldValue(
    //         [...namePath, "valor"],
    //         Number.parseFloat((isNaN(newValue) || newValue === Infinity ? 0 : newValue).toFixed(2))
    //     );
                            
    // }, [valorTotalARatear]);

    return <Tooltip
        placement="top"
        title={
            (percentualForm ?? 0) > 0
                ? `Equivalente a ${
                    ((percentualForm ?? 0) / 100.0) *
                    valorTotalARatear
                } da tarifa`
                : undefined
        }
        open={valorTotalARatear > 0 ? undefined : false}
    >
        <Row gutter={8} wrap style={{ width: "100%" }} align="bottom" justify={"start"}>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
                <Form.Item
                    label="Centro de custo"
                    name={[...nameBase, "centroCusto"]}
                    rules={[{
                        required : true
                    }]}
                >
                    <CentroCustoSelect
                        disabled={disable?.codCentroCusto}
                        onChange={(centoDeCusto) => {
                            const centroDeCustroPadrao = defaultValues?.centroCusto;
                            if (
                                centroDeCustroPadrao != null &&
                                centroDeCustroPadrao.codigo != null &&
                                centroDeCustroPadrao.codigo > 0
                            ) 
                            {
                                form.setFieldValue([...namePath, "centroCusto"], centroDeCustroPadrao);
                                form.setFieldValue([...namePath, "codCentroCusto"], centroDeCustroPadrao?.codigo);
                            }
                            else 
                            {
                                form.setFieldValue([...namePath, "codCentroCusto"], centoDeCusto?.codigo);
                            }
                        }}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
                <Form.Item
                    label="Plano de contas"
                    name={[...nameBase, "planoConta"]}
                    rules={[{
                        required : true
                    }]}
                >
                    <PlanoDeContasSelect
                        disabled={disable?.codPlanoConta}
                        filtros={{
                            tipo : {
                                codigo : isAReceber ? EnumPlanoContasTipoMovimentacao.Receita : EnumPlanoContasTipoMovimentacao.Despesa
                            },
                            tipoRegistro : {
                                codigo : EnumRegistroTipo.Item
                            }
                        }}
                        onChange={(planoDeContas) => {
                            const planoContaPadrao = defaultValues?.planoConta;

                            if (
                                planoContaPadrao != null &&
                                planoContaPadrao.codigo != null &&
                                planoContaPadrao.codigo > 0
                            ) 
                            {
                                form.setFieldValue([...namePath, "planoConta"], planoContaPadrao);
                                form.setFieldValue([...namePath, "codPlanoConta"], planoContaPadrao?.codigo);
                            }
                            else 
                            {
                                form.setFieldValue([...namePath, "codPlanoConta"], planoDeContas?.codigo);
                            }
                        }}
                    />
                </Form.Item>
            </Col>
            <Col xs={12} sm={6} md={4} lg={4} xl={4} xxl={4}>
                <Form.Item
                    label="Percentual"
                    name={[...nameBase, "percentual"]}
                    rules={[{
                        required : true
                    }]}
                >
                    <InputNumber
                        min={0.01} 
                        max={100.00}
                        decimalSeparator={","}
                        style={{ width: "100%" }}
                        precision={4}
                        onChange={(value) => {
                            const newValue = (value ?? 0) / 100 * (valorTotalARatear ?? 0);
                            const valorString = Number.parseFloat((isNaN(newValue) || newValue === Infinity ? 0 : newValue).toFixed(2));
                            form.setFieldValue(
                                [...namePath, "valor"],
                                valorString
                            );
                        }}
                    />
                </Form.Item>
            </Col>
            {
                habilitarValorFixo && <Col xs={12} sm={6} md={4} lg={4} xl={4} xxl={4}>
                    <Form.Item
                        label="Valor (R$)"
                        name={[...nameBase, "valor"]}
                        rules={[{
                            required : false
                        }]}
                    >
                        <InputPreco
                            placeholder="Valor (R$)"
                            addonBefore={<>R$</>}
                            precision={2}
                            decimalSeparator={","}
                            onChange={(value) => {
                                const newValue = (value ?? 0) / (valorTotalARatear ?? 0) * 100.0;
                                form.setFieldValue(
                                    [...namePath, "percentual"], 
                                    Number.parseFloat((isNaN(newValue) || newValue === Infinity ? 0 : newValue).toFixed(4))
                                );
                            }}
                            min={0.01} 
                            max={valorTotalARatear}
                        />
                    </Form.Item>
                </Col>
            }
        </Row>
    </Tooltip>
}